import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Row, Col, FormGroup, Label, Input } from "reactstrap";

//SimpleBar
import SimpleBar from "simplebar-react";

import { Link } from "react-router-dom";

import Select from "react-select";
import moment from "moment";

import {
	getUserLocations,
	getUserSubLocations,
	getMiniDepartment,
	getUserDepartment,
	getMiniProductList,
	getMiniSubOrderLocations,
} from "../../store/Mini/actions";
import {
	FiltershideRightSidebar,
	FilterChangeValue,
	FilterSelecteChangeValue,
	SetParams,
	FilterClear,
	getMyPIReqList,
	getPIReqList,
	getMRList,
} from "../../store/PurchaseIndent/actions";

import "./filtersRightbar.scss";
class FiltertRightbar extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.hideFilterRightbar = this.hideFilterRightbar.bind(this);

		this.FilterChangeHandeler = this.FilterChangeHandeler.bind(this);
		this.applyFilter = this.applyFilter.bind(this);
		this.clearFilter = this.clearFilter.bind(this);
	}
	componentDidMount() {
		this.props.getUserLocations();
		this.props.getUserDepartment();
		this.props.getMiniDepartment();
		this.props.getMiniProductList();
	}

	/**
	 * Hides the right sidebar
	 */
	hideFilterRightbar(e) {
		e.preventDefault();
		this.props.FiltershideRightSidebar();
	}

	FilterChangeHandeler(e) {
		this.props.FilterChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}
	applyFilter() {
		if (this.props.PIFilterlevel === 1) {
			this.props.getMyPIReqList({
				...this.props.params,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? ""
						: moment(this.props.params.end_date)
								.add(1, "days")
								.format("YYYY-MM-DD"),
				page: 1,
			});
		}
		if (this.props.PIFilterlevel === 2) {
			this.props.getPIReqList({
				...this.props.params,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? ""
						: moment(this.props.params.end_date)
								.add(1, "days")
								.format("YYYY-MM-DD"),
				page: 1,
			});
		}
		if (this.props.PIFilterlevel === 3) {
			this.props.getMRList({
				...this.props.params,
				end_date:
					this.props.params.end_date == null ||
					this.props.params.end_date === ""
						? ""
						: moment(this.props.params.end_date)
								.add(1, "days")
								.format("YYYY-MM-DD"),
				page: 1,
			});
		}
		this.props.FiltershideRightSidebar();
	}
	clearFilter() {
		this.props.SetParams({
			...this.props.params,
			page: 1,
			search: "",
			start_date: "",
			end_date: "",
			userdepartment: "",
			department: "",
			location: "",
			product: "",
		});
		if (this.props.PIFilterlevel === 1) {
			this.props.getMyPIReqList({
				...this.props.params,
				page: 1,
				search: "",
				start_date: "",
				end_date: "",
				userdepartment: "",
				department: "",
				location: "",
				piitems__product: "",
			});
		}
		if (this.props.PIFilterlevel === 2) {
			this.props.getPIReqList({
				...this.props.params,
				page: 1,
				search: "",
				start_date: "",
				end_date: "",
				userdepartment: "",
				department: "",
				location: "",
				piitems__product: "",
			});
		}
		if (this.props.PIFilterlevel === 3) {
			this.props.getMRList({
				...this.props.params,
				page: 1,
				search: "",
				start_date: "",
				end_date: "",
				materialrequest__userdepartment: "",
				department: "",
				materialrequest__location: "",
				materialrequest__sublocation: "",
				piitems__product: "",
				materialrequest__orderlocation: "",
			});
		}

		this.props.FilterClear();
		this.props.FiltershideRightSidebar();
	}

	render() {
		return (
			<React.Fragment>
				<div className="filters-right-bar">
					<div className="h-100">
						<div className="rightbar-title px-3 py-4">
							<Link
								to="#"
								onClick={this.hideFilterRightbar}
								className="right-bar-toggle float-right">
								<i className="mdi mdi-close noti-icon"></i>
							</Link>
							<h5 className="m-0">Filters</h5>
						</div>
						<hr className="my-0" />
						<SimpleBar style={{ maxHeight: "100%" }}>
							<div className="px-3 py-4">
								<Row>
									<Col md={12} className="mb-0">
										<FormGroup className="mb-0 pb-0">
											<Label
												htmlFor="validationFromDate"
												className="col-form-label">
												From Date:
											</Label>

											<Input
												className="mb-0 form-control "
												type="date"
												value={
													this.props.params
														?.start_date
												}
												onChange={
													this.FilterChangeHandeler
												}
												id="CProduct-Name-text-input"
												name="start_date"
												placeholder="select Date"
												max={moment(new Date()).format(
													"YYYY-MM-DD"
												)}
											/>
										</FormGroup>
									</Col>
									<Col md={12} className="mb-0">
										<FormGroup className="mb-0 pb-0">
											<Label
												htmlFor="validationToDate"
												className="mb-0 col-form-label">
												To Date:
											</Label>

											<Input
												className="mb-0 form-control "
												type="date"
												value={
													this.props.params?.end_date
												}
												onChange={
													this.FilterChangeHandeler
												}
												id="CProduct-Name-text-input"
												name="end_date"
												placeholder="select Date"
												disabled={
													this.props.params
														.start_date === ""
														? true
														: false
												}
												min={moment(
													this.props.params
														?.start_date
												).format("YYYY-MM-DD")}
												max={moment(new Date()).format(
													"YYYY-MM-DD"
												)}
											/>
										</FormGroup>
									</Col>
									{this.props.PIFilterlevel === 3 && (
										<>
											{/* Location */}
											<Col md={12}>
												<FormGroup className="mb-0">
													<Label
														htmlFor="Location-selection"
														className="col-form-label">
														Locations :
													</Label>
													<Select
														id="Location-selection"
														name="Location-selection"
														classNamePrefix="select2-selection"
														menuPortalTarget={
															document.body
														}
														styles={{
															menuPortal: (
																base
															) => ({
																...base,
																zIndex: 9999,
															}),
														}}
														options={this.props.userLocation.map(
															(item) => ({
																label: item.name,
																value: item.id,
															})
														)}
														value={
															this.props.params
																?.materialrequest__location
																? {
																		label:
																			this
																				.props
																				.filterdata
																				?.locationlabel ||
																			"",
																		value: this
																			.props
																			.params
																			.materialrequest__location,
																  }
																: null
														}
														onChange={(e) => {
															this.props.getUserSubLocations(
																e.value
															);
															this.props.FilterSelecteChangeValue(
																{
																	key: "locationlabel",
																	label: e.label,
																	key2: "materialrequest__location",
																	value: e.value,
																}
															);
														}}
													/>
												</FormGroup>
											</Col>

											{/* Sub Location */}
											<Col md={12}>
												<FormGroup className="mb-0">
													<Label
														htmlFor="SubLocation-selection"
														className="col-form-label">
														Sub Location:
													</Label>
													<Select
														id="SubLocation-selection"
														name="SubLocation-selection"
														classNamePrefix="select2-selection"
														menuPortalTarget={
															document.body
														}
														styles={{
															menuPortal: (
																base
															) => ({
																...base,
																zIndex: 9999,
															}),
														}}
														isDisabled={
															!this.props.params
																?.materialrequest__location
														}
														options={this.props.usersubLocation.map(
															(item) => ({
																label: item.name,
																value: item.id,
															})
														)}
														value={
															this.props.params
																?.materialrequest__sublocation
																? {
																		label:
																			this
																				.props
																				.filterdata
																				?.usersubLocationlabel ||
																			"",
																		value: this
																			.props
																			.params
																			.materialrequest__sublocation,
																  }
																: null
														}
														onChange={(e) => {
															const locationId =
																this.props
																	.params
																	?.materialrequest__location;
															this.props.getMiniSubOrderLocations(
																locationId,
																e.value
															);
															this.props.FilterSelecteChangeValue(
																{
																	key: "usersubLocationlabel",
																	label: e.label,
																	key2: "materialrequest__sublocation",
																	value: e.value,
																}
															);
														}}
													/>
												</FormGroup>
											</Col>

											{/* Order Location */}
											<Col md="12" className="p-1 m-0">
												<FormGroup className="select2-container">
													<Label>
														Order Location
													</Label>
													<Select
														id="orderlocation_id_select"
														name="orderlocation_id_select"
														classNamePrefix="select2-selection"
														isDisabled={
															!this.props.params
																?.materialrequest__sublocation
														}
														options={this.props.suborderlocationslist.map(
															(item) => ({
																label: item.name,
																value: item.id,
															})
														)}
														value={
															this.props.params
																?.materialrequest__orderlocation
																? {
																		label:
																			this
																				.props
																				.filterdata
																				?.orderlocationLabel ||
																			"",
																		value: this
																			.props
																			.params
																			.materialrequest__orderlocation,
																  }
																: null
														}
														onChange={(e) => {
															this.props.MRSelecteChangeValue(
																{
																	key: "orderlocationLabel",
																	label: e.label,
																	key2: "materialrequest__orderlocation",
																	value: e.value,
																}
															);
														}}
													/>
												</FormGroup>
											</Col>
										</>
									)}
									<Col md={12}>
										<FormGroup className="mb-0">
											<Label
												htmlFor="products"
												className="col-form-label">
												Products :
											</Label>

											<Select
												id="products"
												name="products"
												classNamePrefix="select2-selection"
												menuPortalTarget={document.body}
												isSearchable={true}
												styles={{
													menuPortal: (base) => ({
														...base,
														zIndex: 9999,
													}),
												}}
												options={this.props.miniProductList.results.map(
													(item, index) => ({
														label: `${item.name}-${item.code}`,
														value: item.id,
													})
												)}
												onInputChange={(
													inputValue,
													{ action }
												) => {
													if (
														action ===
														"input-change"
													) {
														this.props.getMiniProductList(
															{
																...this.props
																	.miniProductParams,
																page: 1,
																page_size: 10,
																search: inputValue,
																type: 1,
															}
														);
													}
												}}
												onMenuOpen={() => {
													this.props.getMiniProductList(
														{
															...this.props
																.miniProductParams,
															page: 1,
															page_size: 10,
															search: "",
															type: 1,
														}
													);
												}}
												onMenuScrollToBottom={() => {
													if (
														this.props
															.miniProductParams
															.page <
														this.props
															.miniProductParams
															.no_of_pages
													) {
														this.props.getMiniProductList(
															{
																...this.props
																	.miniProductParams,
																page:
																	this.props
																		.miniProductParams
																		.page +
																	1,
																page_size: 10,
																search:
																	this.props
																		.miniProductParams
																		.search ||
																	"",
																type: 1,
															}
														);
													}
												}}
												value={{
													label: this.props.filterdata
														?.piitems__productlabel,
													value: this.props.params
														?.piitems__product,
												}}
												onChange={(e) => {
													this.props.FilterSelecteChangeValue(
														{
															key: "piitems__productlabel",
															label: e.label,
															key2: "piitems__product",
															value: e.value,
														}
													);
												}}
											/>
										</FormGroup>
									</Col>
									{(this.props.PIFilterlevel === 1 ||
										this.props.PIFilterlevel === 2) && (
										<Col md={12}>
											<FormGroup className="mb-0">
												<Label
													htmlFor="Location-selection"
													className="col-form-label">
													Locations :
												</Label>

												<Select
													id="Department-selection"
													name="Department-selection"
													classNamePrefix="select2-selection"
													menuPortalTarget={
														document.body
													}
													styles={{
														menuPortal: (base) => ({
															...base,
															zIndex: 9999,
														}),
													}}
													options={this.props.userLocation.map(
														(item, index) => ({
															label: item.name,
															value: item.id,
														})
													)}
													value={{
														label: this.props
															.filterdata
															?.locationlabel,
														value: this.props.params
															?.location,
													}}
													onChange={(e) => {
														this.props.FilterSelecteChangeValue(
															{
																key: "locationlabel",
																label: e.label,
																key2: "location",
																value: e.value,
															}
														);
													}}
												/>
											</FormGroup>
										</Col>
									)}
									<Col md={12}>
										<FormGroup className="mb-0">
											<Label
												htmlFor="Department-selection"
												className="col-form-label">
												Department :
											</Label>

											<Select
												id="Department-selection"
												name="Department-selection"
												classNamePrefix="select2-selection"
												menuPortalTarget={document.body}
												styles={{
													menuPortal: (base) => ({
														...base,
														zIndex: 9999,
													}),
												}}
												options={this.props.deparmentslist.map(
													(item, index) => ({
														label: item.name,
														value: item.id,
													})
												)}
												value={{
													label: this.props.filterdata
														?.departmentlabel,
													value: this.props.params
														?.department,
												}}
												onChange={(e) => {
													this.props.FilterSelecteChangeValue(
														{
															key: "departmentlabel",
															label: e.label,
															key2: "department",
															value: e.value,
														}
													);
												}}
											/>
										</FormGroup>
									</Col>
									{this.props.PIFilterlevel === 3 && (
										<Col md={12}>
											<FormGroup className="mb-0">
												<Label
													htmlFor="Department-selection"
													className="col-form-label">
													MR User Department :
												</Label>

												<Select
													id="Department-selection"
													name="Department-selection"
													classNamePrefix="select2-selection"
													menuPortalTarget={
														document.body
													}
													styles={{
														menuPortal: (base) => ({
															...base,
															zIndex: 9999,
														}),
													}}
													options={this.props.deparmentslist.map(
														(item, index) => ({
															label: item.name,
															value: item.id,
														})
													)}
													value={{
														label: this.props
															.filterdata
															?.mrUserdepartmentlabel,
														value: this.props.params
															?.materialrequest__userdepartment,
													}}
													onChange={(e) => {
														this.props.FilterSelecteChangeValue(
															{
																key: "departmentlabel",
																label: e.label,
																key2: "materialrequest__userdepartment",
																value: e.value,
															}
														);
													}}
												/>
											</FormGroup>
										</Col>
									)}
									{(this.props.PIFilterlevel === 1 ||
										this.props.PIFilterlevel === 2) && (
										<Col md={12}>
											<FormGroup className="mb-0">
												<Label
													htmlFor="UserDepartment-selection"
													className="col-form-label">
													User Department :
												</Label>

												<Select
													id="UserDepartment-selection"
													name="UserDepartment-selection"
													classNamePrefix="select2-selection"
													menuPortalTarget={
														document.body
													}
													styles={{
														menuPortal: (base) => ({
															...base,
															zIndex: 9999,
														}),
													}}
													options={this.props.userDeparment.map(
														(item, index) => ({
															label: item.name,
															value: item.id,
														})
													)}
													value={{
														label: this.props
															.filterdata
															?.userdepartmentlabel,
														value: this.props.params
															?.userdepartment,
													}}
													onChange={(e) => {
														this.props.FilterSelecteChangeValue(
															{
																key: "userdepartmentlabel",
																label: e.label,
																key2: "userdepartment",
																value: e.value,
															}
														);
													}}
												/>
											</FormGroup>
										</Col>
									)}
								</Row>

								<Row>
									<Col className="mt-1">
										<div className="float-right pt-1">
											<Button
												type="button"
												color="light"
												className="waves-effect waves-light mr-2"
												onClick={this.clearFilter}>
												Clear
											</Button>
											<Button
												type="button"
												color="primary"
												className="waves-effect waves-light"
												onClick={this.applyFilter}>
												Apply
											</Button>
										</div>
									</Col>
								</Row>
							</div>
						</SimpleBar>
					</div>
				</div>

				<div
					className="filters-right-bar-overlay"
					onClick={this.hideFilterRightbar}>
					{" "}
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const {
		userLocation,
		usersubLocation,
		userDeparment,
		deparmentslist,
		miniProductList,
		miniProductParams,
		suborderlocationslist,
	} = state.Mini;
	const { params, filterdata, PIFilterlevel } = state.PurchaseIndent;

	return {
		userLocation,
		usersubLocation,
		userDeparment,
		deparmentslist,
		params,
		filterdata,
		PIFilterlevel,
		miniProductList,
		miniProductParams,
		suborderlocationslist,
	};
};

export default connect(mapStatetoProps, {
	getUserLocations,
	getUserSubLocations,
	getMiniDepartment,
	getUserDepartment,
	FiltershideRightSidebar,
	FilterChangeValue,
	FilterSelecteChangeValue,
	SetParams,
	getMyPIReqList,
	getPIReqList,
	getMRList,
	FilterClear,
	getMiniProductList,
	getMiniSubOrderLocations,
})(FiltertRightbar);
